<template>
  <v-row class="mb-8">
    <v-col cols="12">
      <v-sheet
        v-if="!loading"
        outlined >

        <v-img
          v-if="$vuetify.breakpoint.xsOnly"
          class="image-landing"
          :src="url_banner_sm"
          height="140"
        ></v-img>

        <v-img
          v-if="!$vuetify.breakpoint.xsOnly"
          class="image-landing"
          :src="url_banner"
          height="140"
        ></v-img>

        <v-row class="ma-0">

          <v-col cols="12">
            <h1 class="text-center font-weith-ligth">{{ auditorium.name.toUpperCase() }}</h1>
            <h3 class="text-center font-weith-ligth">Cartelera</h3>
          </v-col>

          <v-col cols="12" class="ma-0">
            <v-list three-line>
              <template v-for="(item, index) in auditorium.activities_programs">
                <v-subheader
                  v-if="item.header"
                  :key="item.header"
                  v-text="item.header"
                ></v-subheader>

                <v-divider
                  v-else-if="item.divider"
                  :key="index"
                  :inset="item.inset"
                ></v-divider>

                <v-list-item
                  v-else
                  :key="item.slug"
                  :to="{ name: 'showActivityAuditorium', params: { activity_slug: item.slug } }"
                >
                  <v-list-item-avatar>
                    <v-img :src="item.url_miniature"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-html="item.name"></v-list-item-title>
                    <v-list-item-subtitle class="text--secondary subtitle-2"><small> {{ convertDate(item.date) }}</small></v-list-item-subtitle>
                    <v-list-item-subtitle v-html="item.description"></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'showAuditorium',
    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      activeChat: true,
      auditorium:[],
      name:null,

      auditorium_slug:null,
      title:'AUDITORIO',

      data:[],

      entrepreneurship:[],

      banner:null,
      url_banner:null,

      banner_sm:null,
      url_banner_sm:null,

      miniature:null,
      url_miniature:null,
      headers: [
          {
            text: 'Fecha',
            align: 'start',
            value: 'date',
          },
          { text: 'Hora', value: 'start_time' },
          { text: 'Actividad', value: 'name' }
        ],
    }),

    computed: {
      ...mapGetters([
        'edition'
      ])
    },

    methods:{
      convertDate(date) {
        if(date!=null){
          const parts = date.split('-');
          const day = parts[2];
          const month = parts[1];
          const year = parts[0];

          return `${day}/${month}/${year}`;
        }

        return null
      },

      async getAuditorium(){
        await axios.get('participant/auditoriums/'+this.edition.edition.id+'/'+this.auditorium_slug ).then(response =>{
          this.data = response.data.data
          this.auditorium = response.data.data.auditorium
          this.url_banner = APP_URL + this.auditorium.banner
          this.url_banner_sm = APP_URL + this.auditorium.banner_sm

          this.auditorium.activities_programs.forEach(element => {
            element.url_miniature = APP_URL + element.miniature
          });
          
          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },
    },

    created(){
       this.auditorium_slug = this.$route.params.auditorium_slug;
       this.getAuditorium()
    },
  }
</script>
<style scoped>

.centered {
  position: absolute;
  top: 35vh;
  left: 50%;
  right:50%;
  transform: translate(0%, -80%);
}

.image-landing{
	position: relative;
	max-width: 100vw;
	width: 100%;
  border-bottom: 5px solid #00a1b8;
}
</style>